<template>
  <div id="friends">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends规则设置</h1>
      </div>

      <div class="header-button">
        <el-button
          icon="el-icon-edit-outline"
          v-if="disabled"
          plain
          @click="modForm"
          >修改</el-button
        >
        <el-button
          icon="el-icon-edit-outline"
          v-if="disabled"
          plain
          @click="saveForm"
          >保存</el-button
        >
      </div>
    </div>

    <el-card shadow="never">
      <div style="">
        <el-form ref="formRef" :model="formData" :disabled="isDisabled">
          <el-form-item>
            <div class="flex-start">
              <span style="margin-right: 10px">陪同购买消费</span>
              <el-input
                style="width: 200px"
                v-model="formData.config_set_1600"
                type="text"
                onkeyup="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span style="margin: 0 10px 0 10px">元获得1积分，该积分在</span>
              <el-input
                style="width: 200px"
                v-model="formData.config_set_1601"
                type="text"
                onkeyup="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span style="margin-left: 10px">天后生效{0表示即时生效}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex-start">
              <span style="margin-right: 10px"
                >顾客使用一张异业礼券后,GIADA Friend获得</span
              >
              <el-input
                style="width: 200px"
                v-model="formData.config_set_1602"
                type="text"
                onkeyup="value=value.replace(/[^\d]/g,'')"
              >
              </el-input>
              <span style="margin-left: 10px">积分</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex-start">
              <span style="margin: 0 10px 0 10px"
                >GIADA Friend绑定的会员升级为</span
              >
              <el-select
                v-model="formData.config_set_1603"
                style="width: 200px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.levelID"
                  :value="item.levelID"
                  :label="item.levelName_cn"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex-start">
              <span style="margin: 0 10px 0 10px"
                >GIADA Friend陪同购买的会员升级为</span
              >
              <el-select
                v-model="formData.config_set_1604"
                style="width: 200px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.levelID"
                  :value="item.levelID"
                  :label="item.levelName_cn"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex-start">
              <span style="margin-right: 10px">GIADA Friend陪同顾客折扣</span>
              <el-input
                style="width: 200px"
                v-model="formData.config_set_1605"
              ></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { queryLSelectApi } from "@/api/user";
import { sysConfigSetQueryApi, sysConfigSetInsertApi } from "@/api/shop";
export default {
  name: "centre",
  data() {
    return {
      isDisabled: true,
      checked: "",
      value: "",
      formData: {},
      options: [],
      disabled: false,
    };
  },
  created() {
    this.formList();
    this.cLvlList();
    let Friends = JSON.parse(localStorage.getItem("Friends"));
    if (Friends.length > 0) {
      this.disabled = true;
    }
  },
  methods: {
    async formList() {
      const res = await sysConfigSetQueryApi({
        cpyNO: getcpyNo(),
      });
      this.formData = res.data;
      console.log(res);
    },
    cLvlList() {
      queryLSelectApi({
        cpyNO: getcpyNo(),
      }).then((res) => {
        this.options = res.data;
        this.options.unshift({
          levelID: 0,
          levelName_cn: "不改变",
        });
        console.log(res, "ggggg");
      });
    },
    // 保存修改数据
    saveForm() {
      sysConfigSetInsertApi({
        cpyNO: getcpyNo(),
        config_set_1600: this.formData.config_set_1600,
        config_set_1601: this.formData.config_set_1601,
        config_set_1602: this.formData.config_set_1602,
        config_set_1603: this.formData.config_set_1603,
        config_set_1604: this.formData.config_set_1604,
        config_set_1605: this.formData.config_set_1605,
      }).then((res) => {
        if (res.success !== true) return this.$message.error("修改失败!");
        this.$message.success("修改成功!");
        this.isDisabled = true;
      });
    },
    modForm() {
      this.isDisabled = false;
    },
  },
};
</script>
<style lang="scss" scoped>
#friends {
  // height: 1000px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  height: 30px;
  border-radius: 0 !important;
}

/deep/.el-select {
  margin-left: 10px;
}
</style>
